module.exports = __webpack_public_path__ + "static/media/rom1.9dda8c28.jpg";